import {CompromiseReportsController} from "./controllers-api/compromise-reports.controller";
import {NetworkService} from "../service/network.service";
import {AttestationController} from "./controllers-api/attestation.controller";
import {FiltreController} from "./controllers-api/filtre-controller";
import {FormatController} from "./controllers-api/format-controller";
import { ScoreController } from "./controllers-api/score-controller";
import { SettingsController } from "./controllers-api/settings.controller";
import { SecurityPoliciesController } from "./controllers-api/security-policies.controllers";
import { RefPoliciesController } from "./controllers-api/ref-policies.controller";
import { BwFiltreController } from "./controllers-api/bw-filtre-controller";
import { BrowserAttestationController } from "./controllers-api/browser-attestation.controller";
import { WpFiltreController } from "./controllers-api/wp-filtre-controller";


/**
 * Centralize the maximum of operations in this class by declare all controller
 */
export class Backend {

  public static SCORE:ScoreController;
  public static FORMAT:FormatController;
  public static FILTRES:FiltreController;
  public static BW_FILTRES:BwFiltreController;
  public static COMPROMISE_REPORTS: CompromiseReportsController;
  public static ATTESTATIONS: AttestationController;
  public static SETTINGS: SettingsController;
  public static POLICIES: SecurityPoliciesController;
  public static REF_POLICIES: RefPoliciesController;
  public static BROWSER_ATTESTATION: BrowserAttestationController;
  public static WP_FILTRES: WpFiltreController;

  /**
   * Inject networkservice for using abstract https methods : get, put, post, patch, delete
   */
  public static set networkService(networkService: NetworkService) {
    this.COMPROMISE_REPORTS = new CompromiseReportsController(networkService);
    this.ATTESTATIONS = new AttestationController(networkService)
    this.FILTRES=new FiltreController()
    this.FORMAT=new FormatController(networkService)
    this.SCORE=new ScoreController()
    this.SETTINGS=new SettingsController(networkService)
    this.POLICIES=new SecurityPoliciesController(networkService)
    this.REF_POLICIES=new RefPoliciesController(networkService)
    this.BW_FILTRES=new BwFiltreController()
    this.BROWSER_ATTESTATION=new BrowserAttestationController(networkService)
    this.WP_FILTRES=new WpFiltreController()
  }

}
